import { createFileRoute } from "@tanstack/react-router"
import { WorkbenchLayout } from "@/features/workbench/components/workbench-layout"
import { fetchSites } from "@/lib/api/sites"
import { fetchAlerts } from "@/lib/api/alerts"
import { fetchInsarDataset } from "@/lib/api/insar"
import { fetchEnvironmentTypes } from "@/lib/api/environment"

export const Route = createFileRoute("/_authenticated/$siteSlug/workbench")({
  loader: async ({ context: { queryClient }, params: { siteSlug } }) => {
    // Prefetch site data (from map loader)
    const sites = await queryClient.ensureQueryData({
      queryKey: ["sites"],
      queryFn: fetchSites,
    })

    // Fire-and-forget prefetches
    void queryClient.ensureQueryData({
      queryKey: ["alerts", { siteSlug, active: true }],
      queryFn: () => fetchAlerts({ siteSlug, active: true }),
    })

    void queryClient.ensureQueryData({
      queryKey: ["environment-types"],
      queryFn: fetchEnvironmentTypes,
    })

    const site = sites.find((s) => s.slug === siteSlug)
    if (site?.insar_dataset) {
      void queryClient.ensureQueryData({
        queryKey: ["insar-dataset", site.insar_dataset],
        queryFn: () => fetchInsarDataset(site.insar_dataset!),
      })
    }
  },
  component: WorkbenchPage,
})

function WorkbenchPage() {
  const { siteSlug } = Route.useParams()
  return <WorkbenchLayout siteSlug={siteSlug} />
}
